module.exports = __webpack_public_path__ + "static/media/activities_movements-min.f34232a1.jpg";